import { createScopedLogger } from 'pi-kiosk-shared/logging';
import { customerLogger } from '../../shared/logging/customerLogger.js';

export const ordersLog = createScopedLogger(customerLogger, { module: 'account', feature: 'orders' });
export const receiptsLog = createScopedLogger(customerLogger, { module: 'account', feature: 'receipts' });
